import { fetchApi } from '@/services/api-client';

export interface CafeteriaSettings {
  /** Whole baht a wallet may go below zero; 0 means never below zero. */
  overdraftLimit: number;
}

const BASE = '/admin/cafeteria/settings';

export const cafeteriaSettingsApi = {
  get: () => fetchApi<CafeteriaSettings>(BASE),
  update: (input: CafeteriaSettings) =>
    fetchApi<CafeteriaSettings>(BASE, { method: 'PUT', body: JSON.stringify(input) }),
};
